import { service } from './service';
import { defaultOptions } from './utils';
import type { IOptions, IConfig, IMiddlewareFn } from './interface';
import type Axios from 'axios';
export function initFetch<T = any>(options: IOptions<T>) {
  const instance = service({
    ...defaultOptions(),
    ...options,
  });
  return function createFetch(
    middleware: IMiddlewareFn[]
  ): (obj: IConfig) => Promise<any> | Axios.IPromise<any> {
    if (!Array.isArray(middleware)) {
      throw new Error('middleware must be an array');
    }
    for (const fn of middleware) {
      if (typeof fn !== 'function')
        throw new Error('middleware must be function');
    }
    if (!middleware || middleware.length < 1) {
      return instance;
    }

    const enhanceFetch =
      middleware.length === 1 ? instance : createFetch(middleware.slice(1));

    const next = middleware[0];

    return function (obj: IConfig) {
      try {
        return Promise.resolve(next(obj, enhanceFetch));
      } catch (e) {
        return Promise.reject(e);
      }
    };
  };
}
